import api from "./api";
// 短链列表
export const postShortLink = params => {
  return api('post', `/v1/management/short-link/list`, params);
};

// 生成短链
export const generateShortLink = params => {
  return api('post', `/v1/management/short-link/generate-short-link`, params);
};
